import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const transactionApi = {
  /**
   *
   * @param {String} token
   * @param {Object} parameters
   * @returns {AxiosPromise}
   */
  requestList(token, parameters) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams(parameters);
    return axios({
      url: '/list',
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
      params,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} id
   * @returns {AxiosPromise}
   */
  requestDetail(token, id) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${id}`,
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} transactionId
   * @returns {AxiosPromise}
   */
  requestTake(token, transactionId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${transactionId}/take`,
      method: 'put',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} transactionId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestUpdate({ token, transactionId, data }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${transactionId}/approval-state`,
      method: 'put',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
      data,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestAlarmTypes(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/alarm_types',
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestRules(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/rules',
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestStatuses(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/states',
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestSummary(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/transaction_summary',
      method: 'get',
      baseURL: APIS.BASE_URL.TRANSACTION,
      headers,
    });
  },
};

export default transactionApi;
